import {
	Component,
	OnInit,
	AfterViewInit,
	HostBinding,
	HostListener,
	Input,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	ViewChild,
	ElementRef,
	OnDestroy
} from '@angular/core';
import { Subscription, fromEvent } from 'rxjs';
import { Announcement } from './../../../../../models/common/announcement';
import { AnnouncementsService } from '../../../../../services/showroom/announcements.service';
import { filter } from 'rxjs/operators';

@Component({
	selector: 'm-notification',
	templateUrl: './notification.component.html',
	styleUrls: ['./notification.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationComponent implements OnInit, AfterViewInit, OnDestroy {
	// @HostBinding('class')
	// tslint:disable-next-line:max-line-length
	// classes = 'm-nav__item m-topbar__notifications m-topbar__notifications--img m-dropdown m-dropdown--large m-dropdown--header-bg-fill m-dropdown--arrow m-dropdown--align-center 	m-dropdown--mobile-full-width';

	// @HostBinding('attr.m-dropdown-toggle') attrDropdownToggle = 'click';
	// @HostBinding('attr.m-dropdown-persistent') attrDropdownPersisten = 'true';

	// @Input() animateShake: any;
	// @Input() animateBlink: any;

  public active = false;
  
  public announcements: Announcement[] = [];

  public newAnnouncementsCount = 0;

  @ViewChild('container') container: ElementRef;
  
  private availableVendors: number[] = [];

	private subscriptions: Subscription[] = [];

	constructor(
		private changeDetection: ChangeDetectorRef,
		private announcementsService: AnnouncementsService
	) {
		// animate icon shake and dot blink
		// setInterval(() => {
		// 	this.animateShake = 'm-animate-shake';
		// 	this.animateBlink = 'm-animate-blink';
		// }, 3000);
		// setInterval(() => (this.animateShake = this.animateBlink = ''), 6000);
	}

	ngOnInit(): void {
		this.announcementsService.getAnnouncements().subscribe(
			(announcements) => {
				this.announcements = announcements;
				this.changeDetection.detectChanges();
			},
			(error) => console.log(error)
    );
    this.announcementsService.getAvailableVendors().subscribe(
      (vendors) => this.availableVendors = vendors,
      (error) => console.log(error)
    );
		this.subscriptions.push(
			this.announcementsService.announcements$
        .pipe(filter(announcement => this.availableVendors.includes(announcement.vendor_id)))
        .subscribe(announcement => {
          this.announcements.unshift(announcement);
          this.newAnnouncementsCount++;
          this.changeDetection.detectChanges();
        })
    );
	}

	ngAfterViewInit(): void {
		let timeout: any;
		this.subscriptions.push(fromEvent(this.container.nativeElement, 'mouseleave')
			.subscribe(event => {
				timeout = setTimeout(() => {
					this.active = false;
					this.changeDetection.detectChanges();
				}, 500);
			}));
		this.subscriptions.push(fromEvent(this.container.nativeElement, 'mouseenter')
			.subscribe(event => {
				clearTimeout(timeout);
			}));
	}

	ngOnDestroy(): void {
		this.subscriptions.forEach(sub => sub.unsubscribe());
	}

	public toggleDropdown(): void {
    this.active = !this.active;
    this.newAnnouncementsCount = 0;
		this.changeDetection.detectChanges();
	}
}
